import { Children, cloneElement } from "react";

import { FeatureType } from "@/features";
import { useMayBeUpsold } from "@/hooks/useMayBeUpsold";
import useSearchParams from "@/hooks/useSearchParams";

import { FeatureProps } from "./type";

import styles from "./Feature.module.css";

export const Upsale: React.FunctionComponent<Omit<FeatureProps, "upsale">> = ({
  asChild,
  required,
  children,
}) => {
  const [_, set] = useSearchParams<{ upsale?: FeatureType }>();
  const upsell = useMayBeUpsold(required);

  if (upsell === false) return null;

  // When clicked - set the upsale modal to show what feature you're missing.
  // Use first feature if array provided
  const handleClick = () => {
    const feature = Array.isArray(required) ? required[0] : required;
    set({ upsale: feature });
  };

  if (asChild) {
    return Children.map(children, (child) => {
      return cloneElement(child as React.ReactElement, {
        onClick: (e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          handleClick();
        },
        href: undefined,
      });
    });
  }

  return (
    <fieldset className={styles.unavailable} role="button">
      {children}
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClick();
        }}
        className={styles.overlay}
      />
    </fieldset>
  );
};
